let _trialPeriodDays: number | undefined;

export function getTrialPeriodDays(): number {
  if (_trialPeriodDays === undefined) {
    const raw = process.env.NEXT_PUBLIC_TRIAL_PERIOD_DAYS;
    if (!raw)
      throw new Error(
        'Missing required env variable: NEXT_PUBLIC_TRIAL_PERIOD_DAYS',
      );
    const parsed = parseInt(raw, 10);
    if (Number.isNaN(parsed))
      throw new Error(
        `Env variable NEXT_PUBLIC_TRIAL_PERIOD_DAYS is not a valid integer: "${raw}"`,
      );
    _trialPeriodDays = parsed;
  }
  return _trialPeriodDays;
}
